import styled from 'styled-components';
import { Button as VeneerButton, Card as VeneerCard, IconWarning as VeneerIconWarning } from '@veneer/core';
import primitives from '@veneer/primitives';
import { LoaderWidget as AddonsLoaderWidget, mixins } from '@jarvis/react-portal-addons';

export const Card = styled(VeneerCard)`
  && {
    width: 100%;
    grid-column: span ${primitives.layout.size3};

    ${mixins.md(`
      grid-column: span 6;
    `)}

    ${mixins.xl(`
      grid-column: span ${primitives.layout.size1};
    `)}
  }
`;

export const CardContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: left;

  ${mixins.xs(`
    width: 100%;
  `)}
`;

export const HeaderContainer = styled.div`
  height: 84px;
  display: flex;
  align-items: center;
  padding-left: ${primitives.layout.size6}px;
  border-bottom: 1px solid ${primitives.color.gray3};
`;

export const HeaderText = styled.h1``;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${primitives.layout.size6}px;
`;

export const ControlButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${primitives.color.gray1};
  border-radius: ${primitives.layout.size3}px;
  gap:  ${primitives.layout.size1}px;
  padding: ${primitives.layout.size1}px;

  ${mixins.sm(`
    flex-direction: row;
  `)}
`;

export const Button = styled(VeneerButton)`
  && {
    height: 40px;

    ${mixins.sm(`
      width: calc(50% - 2px);
    `)};

    color: ${({ isSelected, theme }) => (isSelected ? '' : theme.color.foreground.default)};
  }
`;

export const Description = styled.h2`
  color: ${({ theme }) => theme.color.foreground.medium};
  margin-top: ${primitives.layout.size4}px;
  margin-bottom: ${primitives.layout.size3}px;
`;

export const AddonsWidgetContainer = styled.div`
  width: 100%;
  height: 170px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  border: 1px solid ${primitives.color.gray3};
  text-align: center;
  padding: 0 10px;
  box-sizing: border-box;
`;

export const WarningIconContainer = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${primitives.color.gray3};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const IconWarning = styled(VeneerIconWarning)`
  && {
    rotate: 180deg;
  }
`;

export const NoDataAvailableMessage = styled.span`
  color: ${({ theme }) => theme.color.foreground.medium};
  margin-top: ${primitives.layout.size3}px;
  margin-bottom: ${primitives.layout.size1}px;
`;

export const EmptyStateMessage = styled.span`
  color: ${primitives.color.gray7};
`;

export const LoaderWidget = styled(AddonsLoaderWidget)`
  && {
    min-width: auto;
    color: ${primitives.color.gray7};
  }
`;
